import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Buy Now button.
// - paypalLink present  -> yellow "Buy Now with PayPal" opening PayPal checkout in a new tab.
// - otherwise           -> gold "Request This Service" linking to Contact with service pre-selected.
export default function PayPalButton({ serviceTitle, price, testId, paypalLink }) {
  if (paypalLink) {
    return (
      <div className="w-full">
        <a
          href={paypalLink}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={testId}
          className="group relative flex w-full items-center justify-center gap-2 rounded-md bg-[#FFC439] px-6 py-3 font-bold text-black shadow-sm transition-[transform,box-shadow,background-color] duration-200 hover:-translate-y-0.5 hover:bg-[#f0b72f] hover:shadow-md active:translate-y-0"
        >
          <span className="text-[15px] tracking-tight">Buy Now with</span>
          <span className="text-[16px] font-extrabold leading-none">
            <span className="text-[#003087]">Pay</span>
            <span className="text-[#009cde]">Pal</span>
          </span>
        </a>

        <div className="mt-2 flex items-center justify-center gap-2">
          <div className="flex items-center gap-1.5">
            <CardIcon label="VISA" bg="#1A1F71" />
            <CardIcon label="MC" bg="#EB001B" />
            <CardIcon label="AMEX" bg="#2E77BC" />
            <CardIcon label="DISC" bg="#F1793C" />
          </div>
        </div>
        <p className="mt-1.5 text-center text-[11px] text-slate-400">
          Powered by{" "}
          <span className="font-semibold">
            <span className="text-[#003087]">Pay</span>
            <span className="text-[#009cde]">Pal</span>
          </span>
        </p>
      </div>
    );
  }

  // Request This Service -> Contact page with the service pre-selected
  return (
    <div className="w-full">
      <Link
        to={`/contact?service=${encodeURIComponent(serviceTitle)}`}
        data-testid={testId}
        className="group flex w-full items-center justify-center gap-2 rounded-md bg-[#D4AF37] px-6 py-3 font-semibold text-[#0B1B3D] shadow-sm transition-[transform,box-shadow,background-color] duration-200 hover:-translate-y-0.5 hover:bg-[#e7c96a] hover:shadow-md active:translate-y-0"
      >
        Request This Service
        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
      </Link>
      <p className="mt-2 text-center text-[11px] leading-relaxed text-slate-500">
        We'll confirm your details and email you a secure PayPal invoice.
      </p>
    </div>
  );
}

function CardIcon({ label, bg }) {
  return (
    <span
      className="inline-flex h-4 w-7 items-center justify-center rounded-[3px] text-[7px] font-bold tracking-tight text-white"
      style={{ backgroundColor: bg }}
    >
      {label}
    </span>
  );
}
